module.exports = __webpack_public_path__ + "img/anonima.babca217.png";